<template>
  <div>
    <div class="container-fluid" style="overflow: hidden;">
      <div
        class="mb-3"
        :class="{'section-loading': infoLoading}"
        style="overflow: hidden;max-height: 140px;"
      >
        <div class="float-left w-75 pr-3">
          <h4 class="mb-line text-green mt-0 mb-0">
            {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
            <a
              class="text-orange"
              style="text-decoration:none;"
            >
              <i style="cursor:pointer;" class="icon-attach ml-2" @click="download()">教案(手冊)</i>
            </a>
          </h4>
          <div class="mb-line" style>
            <span
              class="font-weight-bold mr-2"
            >{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span>
            <br />
            <!--<span class="font-weight-bold mr-2" style="color:red;">請注意：同仁如未確實回覆，最高予以停止招攬六個月之處分</span>-->
          </div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line">
            <span class="font-weight-bold mr-2">維護單位</span>
            <span>{{ categoryInfo.dev_name }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">聯絡電話</span>
            <span>{{ categoryInfo.contact }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡分機</span>
            <span>{{ categoryInfo.contact_tel }}</span>
          </div>
          <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
              type="button"
              style="height:43px;"
              @click="backToIndex"
              class="position-absolute btn btn-default m-0"
              v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': isLoading}">
      <div class="row">
        <Suspension-Care-Table
          :height="data_table_height"
          @update="updateSelection"
          @comment-modal="commentModal"
          @jump-to-customer="jumpToCustomer"
          @get-Data="getData"
          @visit-result-modal="VisitResultModal"
          :table-data="tableData"
        />
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-12"></div>
        <div class="col-9 col-sm-8 col-md-8">
          <div class="list inline"></div>
        </div>
        <div class="col-3 col-sm-4 col-md-4 text-right">
          <button
            type="button"
            class="btn btn-primary"
            @click="panelOpen('groupModalOpen')"
            :disabled="!selection.length"
          >加入群組</button>
          <button
            type="button"
            class="btn btn-primary mr-0"
            @click="panelOpen('printModalOpen')"
            :disabled="!selection.length"
          >列印名條</button>
        </div>
      </div>
    </section>

    <!-- 列印名條 -->
    <print-modal :open="printModalOpen" :custs="selection" @close="panelClose('printModalOpen')" />

    <!-- 加入群組 -->
    <group-modal
      :open="groupModalOpen"
      :custs="selection"
      @submit="submitGroup"
      @close="panelClose('groupModalOpen')"
    />

    <comment-modal
      :open="commentModalOpen"
      :comment="comment"
      @close="panelClose('commentModalOpen')"
    />

    <satisfaction-modal
      :open="satisfactionModalOpen"
      @report="report"
      @close="panelClose('satisfactionModalOpen')"
    />

    <visit-result-modal
      :open="VisitResultModalOpen"
      :record="currentRecord2"
      :cat-info="categoryInfo"
      @close="CloseVisitResult"
      @previous="previous"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import PrintModal from "@/desktop/components/PrintModal";
import GroupModal from "@/desktop/components/GroupModal";
import SuspensionCareTable from "../DataTable/SuspensionCareTable";
import CommentModal from "../CommentModal";
import SatisfactionModal from "../SatisfactionModal";
import VisitResultModal from "@/desktop/components/VisitResultModal";
import {
  getSuspensionCare,
  getCategoryDetail,
  isSatisfactionSurveyFinish
} from "@/service";
import { downloadFile_m0 } from "@/service";
import { saveAs } from "file-saver";

export default {
  name: "SuspensionCare",
  mixins: [commonMixin],
  components: {
    SuspensionCareTable,
    CommentModal,
    SatisfactionModal,
    PrintModal,
    GroupModal,
    VisitResultModal
  },
  props: {
    status: String
  },
  computed: {},
  data() {
    //data block layout
    return {
      currentPage: 0,
      isLoading: false,
      isLoading_btn: false,
      isBtnEnble: true,
      infoLoading: false,
      printModalOpen: false,
      groupModalOpen: false,
      tableData: [],
      selection: [],
      commentModalOpen: false,
      satisfactionModalOpen: false,
      comment: "",
      data_table_height: 0,
      NonVisitReasonModalOpen: false,
      VisitResultModalOpen: false,
      categoryInfo: {},
      currentRecord2: {},
      edit_access_index: 0,
      edit_access_name: "",
      info: {},
      sortOrder: 0
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    updateSelection(val) {
      this.selection = val;
    },
    commentModal(comment) {
      this.comment = comment;
      this.panelOpen("commentModalOpen");
    },
    satisfactionModal() {
      this.panelOpen("satisfactionModalOpen");
    },
    report() {
      this.$toast.info({ title: "滿意度調查 已回報" });
      this.isBtnEnble = false;
      this.panelClose("satisfactionModalOpen");
    },
    jumpToCustomer(index) {
      // 導頁到客戶資料
      this.updateCustID(index);
      localStorage.CustID = index;
      this.$router.push({ path: `/detail/CustID/tab/1` });
    },
    backToIndex() {
      // 回上一頁
      this.$emit("change-status", "STATUS_SERVICE_RIGHT_LIST");
    },
    submitGroup(group) {
      // 加入群組導頁至 群組列表
      this.panelClose("groupModalOpen");
      this.$router.push({
        path: `/group/1`,
        query: { grp_id: group.grp_id, grp_name: group.grp_name }
      });
    },
    formatVIP(val) {
      //  轉換 VIP code
      const filterData = [
        { name: "黃金", code: "5" },
        { name: "白金", code: "6" },
        { name: "鑽石", code: "7" }
      ];
      let reData = "";
      filterData.forEach(item => {
        if (val == item.code) {
          reData = item.name;
        }
      });
      return reData;
    },
    formatFet_code(val) {
      //  轉換 契約效力
      const filterData = [
        { name: "停效", code: "01" },
        { name: "終身險滿期", code: "02" },
        { name: "契約終止件(墊繳)", code: "32" },
        { name: "保價返還解約", code: "62" },
        // { name: "正常", code: "00" },
        // { name: "解約辦理中(投資型)", code: "04" },
        // { name: "發函解除", code: "13" },
        // { name: "死殘辦理中", code: "14" },
        // { name: "展期件", code: "20" },
        // { name: "展期滿期件", code: "21" },
        // { name: "繳清件", code: "23" },
        // { name: "繳清滿期件", code: "24" },
        // { name: "解約", code: "30" },
        // { name: "合意解除", code: "31" },
        // { name: "契約終止件(貸款)", code: "33" },
        // { name: "契撤", code: "34" },
        // { name: "契約終止(99或105歲滿期或不續保)", code: "35" },
        // { name: "非終身險滿期", code: "36" },
        // { name: "註銷", code: "37" },
        // { name: "終止", code: "38" },
        // { name: "主被保險人身故(壽險)", code: "40" },
        // { name: "次被保險人身故(年金)", code: "41" },
        // { name: "主被保險人身故(年金)", code: "42" },
        // { name: "主被保險人重大疾病契約終止", code: "43" },
        // { name: "主被保險人殘廢契約終止", code: "44" },
        // { name: "主被保險人生命末期契約終止", code: "45" },
        // { name: "主被保險人醫療契約終止", code: "46" },
        // { name: "防癌主約雙親型本人死亡", code: "47" },
        // { name: "死殘通知件", code: "48" },
        // { name: "主被保險人全殘", code: "50" },
        // { name: "次被保險人全殘(年金)", code: "51" },
        // { name: "主被保險人全殘(年金)", code: "52" },
        // { name: "長期看護", code: "53" },
        // { name: "重大疾病", code: "54" },
        // { name: "貸款停效", code: "61" },
      ];
      let reData = "";
      filterData.forEach(item => {
        if (val == item.code) {
          reData = item.name;
        }
      });
      return reData;
    },
    checkIsSatisfactionSurveyFinish() {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true;
      isSatisfactionSurveyFinish(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        if (result.header && result.header.status == "200") {
          this.isBtnEnble = result.body.isfinish == "0";
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢滿意度調查失敗,請重新操作" });
          }
        }
        this.isLoading_btn = false;
      });
    },
    alreadyDone() {
      this.$toast.info({ title: "您已回報過滿意度調查,無法重複操作" });
    },
    initWarranty() {
      // 資料初始化
      this.checkIsSatisfactionSurveyFinish();
      // 取得列表資料
      this.isLoading = true;
      this.getData(0);
      // 取得專區資訊
      this.getTitleInfo();
    },
    getTitleInfo() {
      // 取得專區資訊
      this.infoLoading = true;
      getCategoryDetail(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.infoLoading = false;
        if (result.header && result.header.status == "200") {
          this.categoryInfo = result.body[0];
        }
      });
    },
    VisitResultModal(record) {
      this.currentRecord2 = record;
      this.panelOpen("VisitResultModalOpen");
    },
    CloseVisitResult() {
      this.panelClose("VisitResultModalOpen");
      this.initWarranty();
    },
    previous() {
      this.panelClose("VisitResultModalOpen");
    },
    download() {
      if (this.$store.state.userInfo.userType === "box") {
        //若内嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(
          this.categoryInfo.upload_file,
          this.categoryInfo.ser_no
        );
      } else {
        let vm = this;
        downloadFile_m0(
          this.$store.state.userInfo.id,
          this.categoryInfo.ser_no,
          this.categoryInfo.upload_file
        ).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            saveAs(result, this.categoryInfo.upload_file);
          }
        });
      }
    },
    getData(value) {
      this.sortOrder = value;
      getSuspensionCare(this.$store.state.userInfo.id, this.sortOrder).then(
        result => {
          this.isLoading = false;
          if (result.header && result.header.status === "200") {
            this.tableData = result.body.lists.map(item => {
              return {
                plcno: item.plcno || "", //保單號碼
                index: item.apc_id || "",
                id: item.apc_id || "", //要保人ID
                name: item.apc_name || "", //要保人姓名
                sex: Number(item.apc_id[1]), //性別
                vip_lv: item.vip_lvl, //顯示VIP
                vip_lvl: this.formatVIP(item.vip_lvl), //VIP等級
                insd_id: item.item || "", //被保人ID
                insd_name: item.insd_name || "", //要保人姓名
                lps_date: item.lps_date || "", //停效日
                reply: item.reply == "Y" ? "已完成" :item.reply == "F" ?"更新失敗，請再次提交" :"未完成", //完成狀態
                reply_code: item.reply_code || "",
                reply_memo: item.reply_memo || "",
                pl_name: item.pl_name || "", //險別名稱
                prod_id: item.prod_id || "", //險別代號
                agnt_name: item.agnt_name || "", //業務員姓名
                fet_code: this.formatFet_code(item.fet_code) || "" ,//契約效力
                is_exist: item.is_exist || false, //判斷是否有客戶資料
              };
            });
            this.registerHanlink(); // for hard word
          }
        }
      );
    }
  },
  mounted() {
    // 資料初始化
    this.initWarranty();
    this.data_table_height =
      parseInt($(window).height()) - $("tbody").offset().top - 80;
    let self = this;
    $(window).bind("orientationchange", function(event) {
      self.data_table_height =
        parseInt($(window).height()) - $("tbody").offset().top - 80;
    });
    $(".tab-content").css("padding-bottom", "74px");
  }
};
</script>
